import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-filter\"><path d=\"M96 284.8a35.2 35.2 0 0 1 35.2-35.2h761.6a35.2 35.2 0 1 1 0 70.4H131.2a35.2 35.2 0 0 1-35.2-35.2zM224 540.8a35.2 35.2 0 0 1 35.2-35.2h505.6a35.2 35.2 0 1 1 0 70.4h-505.6a35.2 35.2 0 0 1-35.2-35.2zM352 796.8a35.2 35.2 0 0 1 35.2-35.2h249.6a35.2 35.2 0 1 1 0 70.4h-249.6a35.2 35.2 0 0 1-35.2-35.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol